import { EmployeeSalary } from "../../types/EmployeeSalary";
import { SalaryActionList, SalaryActions } from "../actions/empSalaryAction";

const initialState: EmployeeSalary[] = [];

export const salaryReducer = (
  state: EmployeeSalary[] = initialState,
  action: SalaryActions,
): EmployeeSalary[] => {
  switch (action.type) {
    case SalaryActionList.ADD_SALARY:
      return [...state, action.data];
    case SalaryActionList.FETCH_SALARYS_EMPLOYEEID:
      return action.data;
    case SalaryActionList.EDIT_SALARY:
      return state.map((salary) =>
        salary.id === action.id ? action.data : salary,
      );
    case SalaryActionList.FETCH_SALARIES:
      return action.data;
    case SalaryActionList.DELETE_SALARY:
      return state.filter((salary) => salary.id !== action.data);
    default:
      return state;
  }
};
